module.exports = __webpack_public_path__ + "img/freelancer_thumbnail-600x450.a2b89d11.jpg";